<template>
  <base-card :projectID="projectID"
             :categoryID="categoryID"
             :storyType="storyType"
             :isMarginless="isMarginless"
             :isRowLoading="isRowLoading"
             :isPinnableRow="isPinnableRow"
             :pinnedProjects="pinnedProjects"
             :disableLink="disableLink"
             :displayType="displayType"
             :flexibleHeight="true"
             :showBookmark="false"
             >
    <information :isRowLoading="isRowLoading"
                 :isBlank="isBlank">
      <div class="upper-container">
        <div class="title-container">
          {{this.project.title}}
        </div>
        <select-schedule :teamID="projectID"/>
      </div>
    </information>
    <div class="judge-team-container">
      <div v-for="(judge,index) in judges"
           @contextmenu.prevent="(e) => rightClickMenu(judge, e)"
           :key="index" class="judge-container"
           :isRowLoading="isRowLoading"
           :isBlank="isBlank">
        <team-member :judge="judge" />
      </div>
    </div>

  </base-card>
</template>

<script>
import BaseCard from './BaseCard'
import base from '../mixins/base'
import visibility from '@/mixins/visibility'
import Information from '../UI/Information'
import imageProxy from '@/libs/image-proxy'
import TeamMember from '../UI/TeamMember'
import SelectSchedule from '../UI/SelectSchedule'
export default {
  name: 'JudgeTeam',
  components: {
    BaseCard,
    Information,
    SelectSchedule,
    TeamMember
  },
  props: {
    projectID: Number,
    categoryID: Number,
    storyType: Boolean,
    isMarginless: [Boolean, String],
    isRowLoading: Boolean,
    isPinnableRow: Boolean,
    pinnedProjects: Array,
    disableLink: Boolean,
    displayType: String
  },
  mixins: [base, visibility],
  computed: {
    judges: function () {
      return this.project.memberships.filter(m => ['Judge Team Member', 'Judge Team Lead'].includes(m.customRole))
    },
    judgeUserAnswers: function () {
      const judgeProject = this.$store.getters.project(this.projectID)
      if (!judgeProject || !judgeProject.pollSummary || !judgeProject.pollSummary.userAnswers) {
        return []
      }
      return judgeProject.pollSummary.userAnswers.map(m => m.answer)
    }
  },
  methods: {
    avatar: function (url) {
      return imageProxy.judges(url)
    },
    rightClickMenu: function (judge, e) {
      const rect = document.getElementById('app')?.getBoundingClientRect()
      if (rect) {
        this.$store.dispatch('showJudgeTeamContextMenu', { x: e.clientX - rect.left, y: e.clientY - rect.top, user: judge, teamID: this.projectID })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .upper-container {
    min-height: 50px;
    margin: 1rem 0.5rem;
    color: black;
    font-weight: bold;
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    justify-content: space-around;
    align-items: center;
  }
  .title-container {
    width: 60%;
    font-size: 1.2rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .judge-team-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .judge-container {
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 100%;
      pointer-events: all;
      cursor: pointer;
      z-index: 1;
      transition: all .5s;
    }
    .judge-container:hover {
      transform: scale(1.1);
      transform-origin: left;
    }
    .leader-icon {
      color: #00ADEE;
    }
  }
  .story-card {
    height: auto !important;
    min-height: fit-content;
  }

</style>
